import React from "react"
import { connect } from "react-redux"
import { MainThunkDispatch } from "../../../../Reducers"
import { validateUserCredentials } from "../../../../Actions/Auth/AuthActions"
import {
    FormData,
    EmailAndPasswordInputRenderContainer
} from "../EmailAndPasswordInputRenderContainer/EmailAndPasswordInputRenderContainer"
import { safePromise } from "../../../../Helpers/Functions/promise"

interface LoginFormProps {
    prefilledEmail?: string
    squashSuccessMessage: boolean
    onSuccess?: () => void
    onForgetPassword: () => void
}

interface StateProps {}

interface DispatchProps {
    login: (data: FormData) => Promise<void>
}

export type Props = LoginFormProps & StateProps & DispatchProps

export const LoginFormIsolated = ({
    prefilledEmail,
    login,
    onSuccess,
    onForgetPassword,
    squashSuccessMessage
}: Props) => {
    return (
        <div>
            <EmailAndPasswordInputRenderContainer
                testId="login-form"
                onSubmit={login}
                onForgetPassword={onForgetPassword}
                submitLabel="Sign in"
                prefilledEmail={prefilledEmail}
                disablePasswordPatternValidation={true}
            />
        </div>
    )
}

const mapDispatchToProps = (
    dispatch: MainThunkDispatch,
    { onSuccess, squashSuccessMessage }: LoginFormProps
): DispatchProps => {
    return {
        login: async ({ email, password }: FormData): Promise<void> => {
            const { error } = await safePromise(
                dispatch(validateUserCredentials(email, password))
            )

            if (onSuccess !== undefined && error === undefined) {
                onSuccess()
            }
        }
    }
}

export const LoginForm = connect(null, mapDispatchToProps)(LoginFormIsolated)
